import { Link } from 'react-router'
import { PigmentTick } from '@/components/primitives/PigmentTick'

interface HalamanSementaraProps {
  judul: string
}

/**
 * Stand-in route content until each section builds its screen: the title row grammar
 * (pigment-tick, Newsreader title) and one Literata sentence. Sections 06 onward replace
 * these elements in router.tsx one by one.
 */
export function HalamanSementara({ judul }: HalamanSementaraProps) {
  return (
    <article className="flex flex-col gap-6 py-6">
      <h1 className="flex items-baseline gap-1 font-display text-title">
        <PigmentTick />
        {judul}
      </h1>
      <p className="measure font-prose text-prose text-muted">
        Halaman ini disiapkan pada tahap berikutnya.
      </p>
    </article>
  )
}

export function TidakDitemukan() {
  return (
    <article className="flex flex-col gap-6 py-6">
      <h1 className="flex items-baseline gap-1 font-display text-title">
        <PigmentTick />
        Halaman tidak ditemukan
      </h1>
      <p className="measure font-prose text-prose text-muted">
        Alamat ini tidak ada di SATU.{' '}
        <Link
          to="/"
          className="text-text underline decoration-border underline-offset-4 hover:text-secondary hover:decoration-secondary"
        >
          Beranda
        </Link>
      </p>
    </article>
  )
}
